export const ROUTEDMODULES: string[] = [
  "4EDD3BF1-FD55-4E0A-8694-F7B0331CD244", // Assets
  "8C8B3AA0-8902-4784-87F3-FF805F461A15", // UserSite
  "33BFAC25-E3F8-4D56-A595-AB5381E81B0B", // GlobalAlerts
  "F945DA36-1669-4397-B547-2CC802633A0D", // Broker
  "739e7683-88f1-4b04-bcfe-5ff8b42de702", // Sentiment
  "ACD7B719-AB8E-4668-B3D4-2E3028CBAD93", // PostTranslation
  "77260808-C9E2-4904-BEFC-8A2FFAA8B7E9", // Configuration
  "F285DA9D-85CA-44FD-A067-4989FF7A98B2", // Payment Transactions
  "070D3E97-C612-44D2-9971-FB5265DE6293", // Storage
  "5A24AD11-92CE-4E7B-B1F0-836385421C79", // WebVitals
  "B929A95B-768C-41FA-8194-E5A4DDEE7509"  // Trading Studio
];



// WEBPACK FOOTER //
// ./src/app/dashboard/services/routed-bomodules.ts